// src/lib/exportUserData.js
//
// Client for the export-user-data edge function (ticket 6b, piece 6).
// Same call-and-error shape as voiceNoteStorage.js's callVoiceNoteStorage:
// a transport-level invokeError vs. a data.error body are both possible
// and both get turned into one thrown Error the caller can show directly.
//
// This module never zips or downloads anything itself -- see the edge
// function's own header for why there's no zip step. It just returns the
// parsed export payload; SettingsPage.jsx drives the actual downloads
// (one for the JSON, one per audio_download_url) since that's a browser
// concern, not a data-fetching one.

import { supabase } from './supabase';

const FUNCTION_NAME = 'export-user-data';

export async function fetchMyDataExport() {
  const { data, error: invokeError } = await supabase.functions.invoke(FUNCTION_NAME, {
    body: {},
  });
  if (invokeError) {
    let message = invokeError.message;
    try {
      const body = await invokeError.context?.json?.();
      if (body?.error) message = body.error;
    } catch {
      // context wasn't JSON or was already consumed -- fall back to
      // invokeError.message rather than masking it with a second error.
    }
    throw new Error(message);
  }
  if (data?.error) throw new Error(data.error);
  return data;
}
